import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';

import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { getPublishDeadlineOptions } from './getPublishDeadlineOptions';
import { PublishRulesDeadlineModesEnum } from '../enums/publishRulesDeadlineModesEnum';
import { IPublishRulesDecisionForm } from '../interfaces/IPublishRulesDecisionForm';

export const getPublishRulesDecisionFormInitialValues: (
  treeItem: IPublishRulesTreeItem,
  decisionStatusesSelectOptions?: ISelectOption[],
) => IPublishRulesDecisionForm = (treeItem, decisionStatusesSelectOptions) => {
  const publishDeadlineImmediatelyOption = getPublishDeadlineOptions().find(
    item => item.value === PublishRulesDeadlineModesEnum.IMMEDIATELY,
  );

  const completeDecisionStatusOption = decisionStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_COMPLETED,
  );

  switch (treeItem.category) {
    case PublishRulesCategoriesEnum.DECISION_PASSPORT:
      return {
        uponAttainingStatus: completeDecisionStatusOption ? [completeDecisionStatusOption] : undefined,
        publishDeadline: publishDeadlineImmediatelyOption,
        additionalSettings: [],
      };
    default:
      return { uponAttainingStatus: undefined, publishDeadline: undefined, additionalSettings: [] };
  }
};
